import { AppNavMenu, AppRoute } from 'src/pages';
import { PatientSearch } from './search';
import { PatientDetails } from './details';
import { UserOutlined } from '@ant-design/icons';

export const patientRoutes: AppRoute[] = [
  {
    path: '/patients',
    element: <PatientSearch />,
  },
  {
    path: '/patients/:patientId',
    element: <PatientDetails />,
  },
];

export const patientNavMenus: AppNavMenu[] = [
  {
    path: '/patients',
    title: 'Patients',
    icon: <UserOutlined />,
  },
];
